import {SearchCriteriaDto} from './search-criteria.dto';

export class SearchDto {
  searchCriteria: SearchCriteriaDto;
  name: string;
}
